@if (display === 'KEY-VALUE-OBJECTS') {
  @for (entry of entries(displayObject().value); track entry) {
    <vitamui-common-data [label]="displayObject().displayRule.ui.label + ' [' + entry[0] + ']'" [value]="entry[1]"> </vitamui-common-data>
  }
}

@if (display === 'ROWS') {
  <div *ngTemplateOutlet="content"></div>
}

@if (display === 'ACCORDION') {
  <vitamui-common-accordion [opened]="displayObject().open">
    <span class="title">{{ displayObject().displayRule.ui.label | translate | empty }}</span>
    @if (favoriteEntry) {
      <div class="title-extra v-col align-items-center favorite-entry">{{ favoritePath | translate }}: {{ favoriteEntry[1] | empty }}</div>
    }
    <div class="content">
      <div *ngTemplateOutlet="content"></div>
    </div>
  </vitamui-common-accordion>
}

<ng-template #content>
  @for (column of rows; track column) {
    <div class="v-row">
      @for (childDisplayObject of column; track childDisplayObject) {
        <div class="v-col">
          @if (!childDisplayObject) {
            <div></div>
          }
          @if (childDisplayObject) {
            <ng-container #displayObject>
              @switch (childDisplayObject.type) {
                @case (DisplayObjectType.GROUP) {
                  <vitamui-common-group [displayObject]="childDisplayObject"></vitamui-common-group>
                }
                @case (DisplayObjectType.LIST) {
                  <vitamui-common-list [displayObject]="childDisplayObject"></vitamui-common-list>
                }
                @case (DisplayObjectType.PRIMITIVE) {
                  <vitamui-common-primitive [displayObject]="childDisplayObject"></vitamui-common-primitive>
                }
              }
            </ng-container>
          }
        </div>
      }
    </div>
  }
  @if (displayObject().value === null || displayObject().value === undefined) {
    <div>{{ displayObject().value | empty }}</div>
  }
</ng-template>
